import { toFormDataIfNeeded } from '@shared/utils/http';
import get from 'lodash-es/get';
import head from 'lodash-es/head';
/**
 * SettingsFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { Fetcher } from '../../fetchers/fetcher';

class SettingsFetcher extends Fetcher {
    _isPublishingEnabled: any;
    _rosterPublishedTo: any;
    get modelName() {
        return 'Settings';
    }

    get resourceName() {
        return 'settings';
    }

    createOrUpdate(body, params = {}) {
        body = toFormDataIfNeeded(body);

        return this.create(body, params);
    }

    key(key, params = {}) {
        return this.all({
            ...params,
            key,
        });
    }

    /**
     * return {Promise}
     */
    isPublishingEnabled(team) {
        if (!team) {
            return Promise.resolve(false);
        }

        return this.key('roster', {
            team,
            count: 1,
            cache: true,
        }).then(response => {
            this._isPublishingEnabled = get(head(response.data), 'value.publishing.enabled');

            return this._isPublishingEnabled;
        }, this._transformError);
    }

    /**
     * return {Promise}
     */
    isXeroEnabled(team) {
        return this.key('xero', {
            team,
            count: 1,
            cache: true,
        }).then(response => get(head(response.data), 'value.enabled'), this._transformError);
    }

    /**
     * return {Promise}
     */
    isBHCCWebrosterEnabled(team) {
        return this.key('bhcc', {
            team,
            count: 1,
            cache: true,
        }).then(response => get(head(response.data), 'value.enabled'), this._transformError);
    }

    publishedTo(team) {
        if (!team) {
            return Promise.resolve(null);
        }

        return this.get('roster/published-to', {
            team,
        }).then(response => {
            this._rosterPublishedTo = get(response.data, 'published_to');

            return this._rosterPublishedTo;
        }, this._transformError);
    }

    rosterThresholds(team, cache = true) {
        return this.key('roster-thresholds', {
            team,
            count: 1,
            cache,
        });
    }

    rosterRestrictions(team, cache = true) {
        return this.key('roster-restrictions', {
            team,
            count: 1,
            cache,
        });
    }
}

export function settingsFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(SettingsFetcher);
    }
}
